import { render, staticRenderFns } from "./dealPwd.vue?vue&type=template&id=04e31d14&"
import script from "./dealPwd.vue?vue&type=script&lang=js&"
export * from "./dealPwd.vue?vue&type=script&lang=js&"
import style0 from "./dealPwd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports